import { configureStore, isRejectedWithValue } from "@reduxjs/toolkit";
import { apiSlice } from "../services/apiSlice";
import tokenRefresher from "../middleware/tokenRefresher";
import authReducer from "../features/auth/authSlice";
import queryScopeReducer from "../features/searchQuery/QuerySlice";
import { forceLocalLogout } from "../features/auth/services/auth";
let lastErrorTime = 0;
const THROTTLE_TIME = 3000;



const rtkQueryErrorLogger = () => (next: any) => (action: any) => {

  const now = Date.now();

  // 401s (including token expiry) are handled by tokenRefresher middleware.
  // Allow them to pass through without forcing a redirect here to avoid loops.
  if (action?.payload?.status === 404) {
    // showToastOutsideReact(
    //   "Invalid credentials",
    //   "invalid credentials - no user found",
    //   "error"
    // );

    return next(action);
  }

  if (
    action?.payload?.status === 504 ||
    action?.payload?.status === "FETCH_ERROR"
  ) {
    const user = localStorage.getItem("authData");
    if (user && now - lastErrorTime > THROTTLE_TIME) {
      //   showToastOutsideReact(
      //     "Failed to process your request.",
      //     "504: Please contact IT Support.",
      //     "error"
      //   );
      lastErrorTime = now;
    }
    return next(action);
  }

  // If any RTK Query request comes back with the backend message
  // "Portal access not enabled for this contact", force a local logout
  // so the user is returned to a public / login state.
  const message = action?.payload?.data?.message || action?.payload?.data?.error;
  if (typeof message === "string" && message.toLowerCase().includes("portal access not enabled for this contact".toLowerCase())) {
    forceLocalLogout();
    return next(action);
  }

  if (isRejectedWithValue(action)) {
    console.warn("We got a rejected action!");
    // action?.payload?.data?.error !== "Please activate your account first" &&
    //   !Array?.isArray(action?.payload?.data?.error) &&
    //   showToastOutsideReact(
    //     action?.payload?.data?.error ||
    //       action?.payload?.data?.message ||
    //       "Something went wrong!",
    //     "Something went wrong!",
    //     "error"
    //   );
    lastErrorTime = now;
  }
  return next(action);
};


export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
      auth: authReducer,
      queryScope:queryScopeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(tokenRefresher) // <- should come BEFORE apiSlice.middleware
      .concat(apiSlice.middleware)
      .concat(rtkQueryErrorLogger),
  devTools: process.env.NODE_ENV !== "production",
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
